import { useContext, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { LocaleContext } from "../routing/LangRouter";
import { useTranslation } from "react-i18next";

//import images and icons
import errorImage1 from "../assets/imgs/err1.png";
import errorImage2 from "../assets/imgs/err2.png";
import botImageFa from "../assets/imgs/error-bot-fa.png";
import botImageEn from "../assets/imgs/error-bot-en.png";
import { Home, Refresh } from "iconsax-react";

function ErrorBoundaryFallback({ error, resetErrorBoundary }) {
    //general
    const [searchParams] = useSearchParams();
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();

    const [isCopied, setIsCopied] = useState(false);

    // This is the function we wrote earlier
    async function copyTextToClipboard(text) {
        if ("clipboard" in navigator) {
            return await navigator.clipboard.writeText(text);
        } else {
            return document.execCommand("copy", true, text);
        }
    }

    // onClick handler function for the copy button
    const handleCopyClick = () => {
        // Asynchronously call copyTextToClipboard
        copyTextToClipboard(searchParams.get("errorId"))
            .then(() => {
                // If successful, update the isCopied state value
                setIsCopied(true);
                setTimeout(() => {
                    setIsCopied(false);
                }, 1500);
            })
            .catch(err => {
                console.log(err);
            });
    };

    return (
        <div className="error-page">
            <img className="error-header" src={errorImage1} />
            <div className="error-content">
                <img className="error-bot" src={locale === "en" ? botImageEn : botImageFa} />
                <button className="try-again" onClick={resetErrorBoundary}>
                    {" "}
                    {t("retry")} <Refresh color="#006363" />
                </button>
                <div className="error">
                    <span>شماره پیگیری خطا:</span>
                    <div className="error-box">
                        <input className="error-text" type="text" value={searchParams.get("errorId")} readOnly />
                        {/* Bind our handler function to the onClick button property */}
                        <button className="copy-button" onClick={handleCopyClick}>
                            <span>{isCopied ? t("copyed") : t("copy")}</span>
                        </button>
                    </div>
                </div>
                <div className="links">
                    <span>{t("goTo")}:</span>
                    <Link className="home-page" to={`/`}>
                        <Home color="#808080" /> {t("homePage")}{" "}
                    </Link>
                </div>
            </div>
            <img className="error-header" src={errorImage2} />
        </div>
    );
}

export default ErrorBoundaryFallback;
